import React, { useMemo } from 'react';
import NextLink from 'next/link';
import { SvgIcon } from 'components/helpers/SvgIcon';
import styles from './HeaderAccount.module.scss';

export interface MyFavouritesProps {
  favouritesCount: number;
  favouritesUrl?: string;
  label?: string;
  textLabel?: string;
  icon?: React.ReactNode;
}

export const MyFavourites: React.FC<MyFavouritesProps> = ({
  favouritesCount,
  favouritesUrl,
  label,
  textLabel: _textLabel,
  icon,
}) => {
  const displayCount = useMemo(() => {
    if (favouritesCount > 9999) return '9999+';
    return favouritesCount.toString();
  }, [favouritesCount]);

  const ariaLabel = `${label || 'My Favourites'} - ${displayCount} saved items`;

  return (
    <NextLink
      href={favouritesUrl || '/user-profile'}
      className={styles.favouritesButton}
      aria-label={ariaLabel}
    >
      <span className={styles.heartIcon}>
        {icon || <SvgIcon icon="heart-favorites" viewBox="0 0 20 17" aria-hidden="true" />}
      </span>
      <span className={styles.favouritesCount} aria-live="polite">
        {displayCount}
      </span>
    </NextLink>
  );
};
